import { createContext } from 'react';

import { ActiveFilter, FilterConfig } from 'dashboard/components-lib/TableControls/types';

interface TableControlsContextProps {
  filters: FilterConfig[];
  activeFilters: ActiveFilter[];
  setActiveFilters: (filters: ActiveFilter[]) => void;
}

const TableControlsContext = createContext<TableControlsContextProps>({
  filters: [],
  activeFilters: [],
  setActiveFilters: () => {},
});

export default TableControlsContext;
